import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import SelectQuestionViewModel from '../../SelectQuestionViewModel'

export default function SelectValue({
  vm,
}: ValueComponentProps<SelectQuestionViewModel>) {
  return <>{vm.toTextAnswer()}</>
}
